import { getMonth, getYear } from "date-fns";
import { v4 as uuidv4 } from "uuid";
import { encryptNativeSpeedPay } from "./utils";
import { EC_DW_LOGGING_STEPS, publicKeySpeedPay } from "../../../shared/utils/Constants";
import {
  updatePaymentMethod,
} from "../../../shared/hooks/useFetchPayment";
import DwLogutil from "./DwLogutil";

export const getCardTypeByCardNumber = (value: string) => {
  value = value.replace(/\s+/g, '').replace(/-/g, '');

  if (
    (value?.startsWith("34") || value?.startsWith("37")) &&
    value?.length === 15
  ) {
    // American Express
    return "AmericanExpress";
  } else if (/^4\d{12}(?:\d{3})?$/.test(value)) {
    // Visa
    return "Visa";
  } else  if (/^5[1-5]\d{14}$/.test(value) || /^222[1-9]\d{12}$|^22[3-9]\d{13}$|^2[3-6]\d{14}$|^2720\d{12}$/.test(value)) {
    // MasterCard
    return "MasterCard";
  } else  if (/^6011\d{12}$|^622(?:126|127|128|129|12[0-5]|2[0-9]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-5])\d{10}$|^64[4-9]\d{13}$|^65\d{14}$/.test(value)) {
    // Discover
    return "Discover";
  } else if (
    (["36", "38"]?.includes(value?.substring(0, 2) || "") ||
      ["300", "301", "302", "303", "304", "305"]?.includes(
        value?.substring(0, 3) || ""
      )) &&
    value?.length === 14
  ) {
    // Diners Club
    return "DinersClub";
  } else if (
    (["2131", "1800"]?.includes(value?.substring(0, 4) || "") &&
      value?.length === 15) ||
    (value?.startsWith("35") && value?.length === 16)
  ) {
    // JCB
    return "JCB";
  } else {
    return "";
  }
};

export const validateCreditCardNumber = (value: string) => {
  value = value?.replaceAll(" ", "");
  if (
    (value?.startsWith("34") || value?.startsWith("37")) &&
    value?.length === 15
  ) {
    // AmericanExpress
    return true;
  } else if (/^4\d{12}(?:\d{3})?$/.test(value)) {
    // Visa
    return true;
  } else if (/^5[1-5]\d{14}$/.test(value) || /^222[1-9]\d{12}$|^22[3-9]\d{13}$|^2[3-6]\d{14}$|^2720\d{12}$/.test(value)
  ) {
    // MasterCard
    return true;
  } else  if (/^6011\d{12}$|^622(?:126|127|128|129|12[0-5]|2[0-9]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-5])\d{10}$|^64[4-9]\d{13}$|^65\d{14}$/.test(value)) {
    // Discover
    return true;
  } else if (
    (["36", "38"]?.includes(value?.substring(0, 2) || "") ||
      ["300", "301", "302", "303", "304", "305"]?.includes(
        value?.substring(0, 3) || ""
      )) &&
    value?.length === 14
  ) {
    // DinersClub
    return true;
  } else if (
    (["2131", "1800"]?.includes(value?.substring(0, 4) || "") &&
      value?.length === 15) ||
    (value?.startsWith("35") && value?.length === 16)
  ) {
    // JCB
    return true;
  } else {
    return false;
  }
};

export const validateCreditCardNumberAllowed = (value: string) => {
  value = value?.replaceAll(" ", "");
  if (/^4\d{12}(?:\d{3})?$/.test(value)) {
    // Visa
    return true;
  } else if (/^5[1-5]\d{14}$/.test(value) || /^222[1-9]\d{12}$|^22[3-9]\d{13}$|^2[3-6]\d{14}$|^2720\d{12}$/.test(value)
  ) {
    // MasterCard
    return true;
  } else  if (/^6011\d{12}$|^622(?:126|127|128|129|12[0-5]|2[0-9]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-5])\d{10}$|^64[4-9]\d{13}$|^65\d{14}$/.test(value)) {
    // Discover
    return true;
  } else {
    return false;
  }
};

export const emailRegex =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
export const accountNumberRegex = /^[0-9 ]*$/;
export const phoneNumberRegex =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/;
export const validateAccountNumber = (value: string | undefined) => {
  // value = value?.replaceAll(" ", "");
  if (
    value &&
    value?.length > 0 &&
    accountNumberRegex?.test(value) &&
    [9, 11, 13]?.includes(value?.length)
  ) {
    // [9, 11, 13] Account Number can be 9, 11, 13 digit
    return true;
  } else if (value && value?.length > 0 && phoneNumberRegex?.test(value)) {
    return true;
  } else if (value && value?.length > 0 && emailRegex?.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const formatPhoneNumberInput = (phoneNumberString: string) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    cleaned = cleaned.slice(1);
  }
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return phoneNumberString;
};





export const validateExpirationDate = (value: string | undefined) => {
  if(!value?.includes("/")){
    return false;
  }
  if (value) {
    const [valueMonth, valueYear] = value?.split("/");
    const currentMonth = getMonth(new Date());
    const currentYear = getYear(new Date());
    if (
      valueMonth?.length === 2 &&
      valueYear?.length === 4 &&
      (parseInt(valueYear) < currentYear ||
        (parseInt(valueYear) === currentYear &&
          parseInt(valueMonth) <= currentMonth))
    ) {
      return false;
    }
  }
  return true;
};

export const validateExpirationDateCtl = (value: string | undefined) => {
  if (value) {
    const [valueMonth, valueYear] = value?.split("/");
    const currentMonth = getMonth(new Date());
    const currentYear = parseInt(getYear(new Date()).toString().substr(-2));
    if (
      valueMonth?.length === 2 &&
      valueYear?.length === 2 &&
      (parseInt(valueYear) < currentYear ||
        (parseInt(valueYear) === currentYear &&
          parseInt(valueMonth) <= currentMonth))
    ) {
      return false;
    }
  }
  return true;
};

export const validateBankAccount = (value: string | undefined) => {
  value = value?.replaceAll(" ", "");
  if (value?.length === 10) {
    return true;
  } else {
    return false;
  }
};

export const maskCreditCardNumber = (value: string | undefined | null) => {
  value = value?.replaceAll(" ", "");
  let newValue = "";
  switch (value?.length) {
    case 13:
      newValue = value?.slice(9);
      break;
    case 14:
      newValue = value?.slice(10);
      break;
    case 15:
      newValue = value?.slice(11);
      break;
    case 16:
      newValue = value?.slice(12);
      break;
    default:
      break;
  }

  return newValue;
};
export const capitalizeFirstLetter = (value: string) => {
  /* This function will convert the first letter in uppercase from word */
  return (value.trim())?value?.charAt(0)?.toUpperCase() + value?.slice(1)?.toLowerCase() : "";
};
export const validateCVVSpeedPay = async (cardDetails:any) =>{
  
        /* Validate the CVV */
        const expirationDateSlitData = cardDetails?.expirationDate?.split("/");
        const expirationMonth = expirationDateSlitData[0];
        const expirationYear = parseInt(
          expirationDateSlitData[1]?.length > 2
            ? expirationDateSlitData[1]?.slice(2)
            : expirationDateSlitData[1]
        );
      const unencrypted_values = "##" + cardDetails?.cvv + "#" +
      expirationMonth +
      "#" + expirationYear;
      const encryptData = await encryptNativeSpeedPay(unencrypted_values, publicKeySpeedPay);

      return await updatePaymentMethod(
      { [cardDetails?.ApiUrls]: cardDetails?.cardId },
      {
      baseline: {
        siteId: cardDetails?.headers?.siteId?.toLowerCase(),
        transactionId: uuidv4(),
      },
      cardHolderName: cardDetails?.accountHolderName,
      banNumber: cardDetails?.banNumber,
      kind: "Card",
      paymentMethodKind: cardDetails?.paymentMethodKind,
      encValues: encryptData,
      billingType: cardDetails?.billingType,
      email: cardDetails?.email,
      },
      cardDetails?.headers
      );
      //return response;
}

export function isCurrentTimeInRange(startDate:any, endDate:any) {
  const now = new Date();  // Get current date and time
  // Convert start and end date strings to Date objects
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  // Check if the current time is between the two dates
  return start <= now  && now <= end;
}

export const logDwFailure = (key: string,error: string,flowType: string) => {
  let stepName: string | undefined;
  const email= localStorage.getItem("emailID") || ""

  switch (key) {
    case 'login':
      stepName = EC_DW_LOGGING_STEPS.login_failed;
      break;
    case 'Registration':
      stepName = EC_DW_LOGGING_STEPS.registration_failed;
      break;
    case 'find-user-name':
      stepName = EC_DW_LOGGING_STEPS.find_user_name_failed;
      break;
  }
  if(stepName && error){
  DwLogutil({
          stepName,
          error,
          flowType,
          email
  });
  }

}
